export default __webpack_public_path__ + "static/media/Shot_9.0000.cbe63d64.png";